import _ from 'lodash'
import { executeAction, getUpdateBox2dAction } from '@ps/workbench/undo-redo'
import * as editorScript from '@ps/bridge/qc/scripts/editor'

export default {
  updateBox2d({ state }, { node, box2d }) {
    const ped = editorScript.getScript(node)
    const oldBox2d = _.cloneDeep(ped.$data.box2d)
    executeAction({
      action: getUpdateBox2dAction({
        node,
        newValue: box2d,
        oldValue: oldBox2d,
      }),
    })
  },
}
